import { Circle } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { lightOrDark } from "utils/color-utils";
import { SMTooltip } from "./lib/SMTooltip";

export const TierCircle = (props: { color: string; name?: string }) => {
  const theme = useTheme();

  const circle = (
    <Circle
      stroke={theme.palette.mode == "light" && lightOrDark(props.color) == "light" ? "#46494c" : undefined}
      strokeWidth={theme.palette.mode == "light" ? 1.5 : undefined}
      sx={{
        color: props.color,
      }}
    />
  );
  if (props.name) {
    return (
      <SMTooltip arrow title={props.name}>
        {circle}
      </SMTooltip>
    );
  }
  return circle;
};
